<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-form>
            <v-container fluid>
                <v-layout>
                    <v-flex md4>
                        <v-text-field label="Select File" @click="selectFile" v-model="fileName" readonly="readonly"></v-text-field>
                        <input
                                type="file"
                                style="display: none"
                                @change="processFile"
                                ref="spreadsheetInput">
                    </v-flex>
                    <v-flex md4>
                        <v-checkbox label="Do Not Send E-Mail Notifications (You Can Do This Later)" v-model="isSuppressEmails"></v-checkbox>
                    </v-flex>
                </v-layout>
                <v-btn outlined color="primary" @click="save()" :disabled="isSubmitting">Upload</v-btn>
                <v-progress-circular
                    :width="3"
                    v-show="isSubmitting"
                    color="red"
                    indeterminate="">
                </v-progress-circular>
			 <v-alert v-if="spreadsheetSuccess" type="success" class="mt-1">
				  Spreadsheet Processed!
			 </v-alert>
			 <v-alert v-if="errors != null" type="error" class="mt-1">
				 One Or More Errors Were Found In the Spreadsheet. Please Correct and Re-upload
			 </v-alert>
                <v-data-table v-if="errors != null" :headers="headers" :items="errors" class="elevation-1 mt-1" hide-default-footer="true">
                    <template v-slot:items="props">
                        <td>{{props.item.sheetName}}</td>
                        <td>{{props.item.lineNumber}}</td>
                        <td>{{props.item.message}}</td>
                    </template>
                </v-data-table>
            </v-container>
        </v-form>
    </div>
</template>

<script>

    import api from '@/api';

    export default {
	   inject: ['getProvidedOrganization'],
        data() {
            return {
                headers : [
                    {text:'Sheet',value:'sheetName'},
                    {text:'Line Number',value:'lineNumber'},
                    {text:'Message',value:'message'}
                ],
                isSubmitting: false,
			    spreadsheetSuccess : false,
                file : null,
                fileName : null,
                errors : null,
                isSuppressEmails : true
            }
        },
        methods: {
            selectFile : function() {
                this.$refs.spreadsheetInput.click();
            },
            save:function() {

                if (!this.file) {
                    this.$root.$emit('globalError','Please Select a Spreadsheet to Upload');
                    return;
                }
			 const organizationId = this.getProvidedOrganization().id;
                this.errors = null;
                this.spreadsheetSuccess = false;

                this.isSubmitting = true;
                api.organization.spreadsheet.post(organizationId,this.file, this.isSuppressEmails).then(() => {
                    this.isSubmitting = false;
				    this.spreadsheetSuccess = true;
                },(error) => {
                    this.errors = error.errors;
                    this.$refs.spreadsheetInput.value = '';
                }).finally(() => {
                    this.isSubmitting = false;
				    this.file = null;
				    this.fileName = null;
                });

            },
            processFile(e) {

                const files = e.target.files;
                if (files != null && files.length > 0) {
                    this.fileName = files[0].name;
                    this.file = files[0];
                } else {
                    this.file = null;
                    this.fileName = null;
                }
            }
        }
    }
</script>